

let prodLines = [];
let sRecords = [];
let docText = '';
let ssvLines = [];
let columnIndexes = [];
let containsBadTimeData = false;
let requiredSrcFields = [
  'depthMax',
  'diameter',
  'file',
  'machineId',
  'materialVolume',
  'pointId',
  'pumpStrokeVol',
  'timeBegin',
  'timeEnd'
];
let durationDrillName = 'durationPen';
let missingSrcFields = [];
let hasPumpStrokeColumn = 'false';

class ProdLine {
  constructor(record, isMetric, hasPumpStrokeColumn, durationDrillName) {
    let fileName = '';
    let fullFileName = record['file'];
    let fNameParts = fullFileName.split('/');
    if (fNameParts.length > 0) {
      fileName = fNameParts[fNameParts.length - 1];
    }
    this.fileName = fileName;
    this.elementId = record['pointId'];

    this.date = '';
    this.timeStart = '';
    this.timeToBottom = parseFloat(record[durationDrillName]);
    this.timeFinish = 0;
    this.installTime = 0;
    this.timeBetweenCmcs = 0;
    this.reasonForDelay = '';
    this.diameter = 0;
    this.rig = '';
    this.elementType = 'Production'
    this.length = 0;
    this.pumpStrokes = 0;
    this.torque = '';
    this.calibrationFactor = '';
    this.omniboxRigName = record['machineId'];
    this.dateOnly = 0;

    let pumpStrokes = 0;
    if (hasPumpStrokeColumn) {
      pumpStrokes = parseFloat(record['pumpStrokes']);
    }
    else {
      let mVolume = parseFloat(record['materialVolume']);
      let psVolume = parseFloat(record['pumpStrokeVol']);
      if (mVolume > 0 && psVolume > 0) {
        pumpStrokes = mVolume / (psVolume / 1000);
      }
    }
    this.pumpStrokes = pumpStrokes;

    //unit conversion props
    if (isMetric) {
      let diameterM = parseFloat(metersToInches(record['diameter']));
      this.diameter = roundToFixed(diameterM, 1);
      this.length = roundToFixed(Math.abs(metersToFeet(record['depthMax'])), 4);
    }
    else {
      let diameter = parseFloat(record['diameter']);
      this.diameter = roundToFixed(diameter, 1);
      this.length = roundToFixed(Math.abs(parseFloat(record['depthMax'])), 4);
    }
  }
}

// ----- utils -----


function roundToFixed(input, digits) {
  let rounded = Math.pow(10, digits);
  return (Math.round(input * rounded) / rounded).toFixed(digits);
}

function minutesBetween(startTime, endTime) {
  let minBetween = 0;
  let ticsBetween = endTime - startTime;
  if (ticsBetween > 0) {
    minBetween = ticsBetween / 1000 / 60;
  }
  return minBetween;
}

function metersToInches(meters) {
  return meters * 39.3701;
}

function metersToFeet(meters) {
  return meters * 3.28084;
}

function formatDateTime(dt) {
  let dtString = (dt).toISOString();
  if (dtString.indexOf('T') > -1) {
    return (dt).toISOString().slice(0, 19).replace(/-/g, '/').replace('T', ' ');
  }
  else {
    return (dt).toISOString().slice(0, 19).replace(/-/g, '/');
  }
}

function parseTimeStamp(dateTimeText) {
  let ts = '';
  let parts = dateTimeText.split(' ');
  if (parts.length > 4) {
    ts = parts[4];
  }
  return ts;
}


// ----- app functions -----
function getProductionLines(sRecords, isMetric, durationDrillName) {
  let prodLines = [];
  for (const record of sRecords) {
    let line = new ProdLine(record, isMetric, hasPumpStrokeColumn, durationDrillName);
    line.date = new Date(record['timeEnd']);
    line.timeStart = new Date(record['timeBegin']);
    line.timeFinish = new Date(record['timeEnd']);
    prodLines.push(line);
  }
  return prodLines;
}

function getPartialProductionLines(sRecords, isMetric, durationDrillName) {
  let prodLines = [];
  for (const record of sRecords) {
    let line = new ProdLine(record, isMetric, hasPumpStrokeColumn, durationDrillName);
    line.date = record['TimeEnd'];
    line.timeStart = record['timeBegin'];
    line.timeFinish = record['timeEnd'];
    prodLines.push(line);
  }
  return prodLines;
}

function generateProdLinesCsv(objArray, delim, includeHeader) {
  if (objArray.length === 0) {
    alert('Sorry, array is empty. Cannot generate comma separated values.');
    return '';
  }

  let resultString = '';
  let firstRow = objArray[0];
  let propNames = Object.keys(firstRow);

  if (includeHeader) {
    propNames.forEach(propName => {
      resultString += propName + delim;
    });
    resultString += '\r\n';
  }

  objArray.forEach(obj => {
    propNames.forEach(propName => {
      let propVal = obj[propName];
      if (propVal !== null || propVal !== undefined) {
        if (propName === 'date') {
          propVal = formatDateTime(propVal);
        }
        else if (propName === 'timeStart' || propName === 'timeFinish') {
          propVal = parseTimeStamp(propVal + '');
        }
      }

      resultString += propVal + delim;
    });

    resultString += '\r\n';
  });
  return resultString;
}

function setTimesBetween(prodLines) {
  //get distinct dates in prodLines, group lines by date
  sortProdLines(prodLines);

  let lastRigName = '';
  let lastEndTime = new Date('2021-06-01');
  let defaultEndTime = new Date('2021-06-01');

  for (const line of prodLines) {
    if (line.omniboxRigName !== lastRigName) {
      line.timeBetweenCmcs = 0;
    }
    else {
      if (lastEndTime !== defaultEndTime) {
        let tb = roundToFixed((line.timeStart - lastEndTime) / 1000 / 60, 2);
        if (tb < 0 || tb > 3600) tb = 0;
        line.timeBetweenCmcs = tb;
      }
      else {
        line.timeBetweenCmcs = 0;
      }
    }

    lastRigName = line.omniboxRigName;
    lastEndTime = line.timeFinish;
  }
}

// sorts prodLines by date, then rig, then start time. required to calculate time between cmcs
function sortProdLines(prodLines) {
  prodLines.sort(function (a, b) {
    if (a.dateOnly > b.dateOnly) return 1;
    else if (a.dateOnly < b.dateOnly) return -1;
    else if (a.omniboxRigName > b.omniboxRigName) return 1;
    else if (a.omniboxRigName < b.omniboxRigName) return -1;
    else if (a.timeStart > b.timeStart) return 1;
    else if (a.timeStart < b.timeStart) return -1;
    return 0;
  });
}


// ----- Main function -----
export function readFile(file, unitSystem) {
  return new Promise((resolve, reject) => {
    const isMetric = (unitSystem === 'metric') ? (true) : (false);
    const reader = new FileReader();
    reader.readAsText(file, 'UTF-8');
    reader.onload = readerEvent => {
      docText = readerEvent.target.result;
      const docLines = docText.split('\n');
      if (docLines.length > 0) {
        let headerRow = docLines[0];
        let firstDataRow = 1;

        // check to see if file has two header rows, skip the top category row if it does
        if (docLines[0].includes('General;')) {
          headerRow = docLines[1];
          firstDataRow = 2;
        }
        let colNames = headerRow.split(';');
        if (colNames.includes('durationDrill')) {
          durationDrillName = 'durationDrill';
        }
        requiredSrcFields.push(durationDrillName);
        for (let i = 0; i < colNames.length; i++) {
          let colIndex = {
            name: colNames[i],
            index: i
          }
          columnIndexes.push(colIndex);
        }

        for (let i = 0; i < requiredSrcFields.length; i++) {
          let fieldName = requiredSrcFields[i];
          if (colNames.includes(fieldName) === false) {
            missingSrcFields.push(fieldName);
          }
        }

        //check source file for required columns
        if (missingSrcFields.length > 0) {
          alert('Omnibox source file is missing the following required fields: ' + missingSrcFields.join(','));
          return;
        }

        // check if pumpstrokes column exists
        if (colNames.includes('pumpStrokes')) {
          hasPumpStrokeColumn = true;
        }

        // parse json from omnibox output file
        let ssvLines = [];
        for (let i = firstDataRow; i < docLines.length - 1; i++) {
          let ssvLine = docLines[i];
          let lineParts = ssvLine.split(';');
          let maxCols = colNames.length;
          if (lineParts.length >= maxCols) {
            let sRecord = {}
            for (let c = 0; c < maxCols; c++) {
              sRecord[colNames[c]] = lineParts[c];
            }
            sRecords.push(sRecord);
          }
        }

        // check for bad data in datetime fields
        for (let i = 0; i < sRecords.length; i++) {
          let sRecord = sRecords[i];
          if (sRecord['timeBegin'] === undefined || sRecord['timeBegin'] === '' || sRecord['timeBegin'] === 'NaN') {
            containsBadTimeData = true;
            break;
          }
          if (sRecord['timeEnd'] === undefined || sRecord['timeEnd'] === '' || sRecord['timeEnd'] === 'NaN') {
            containsBadTimeData = true;
            break;
          }
        }

        if (!containsBadTimeData) {
          // if there are no bad time data, generate production
          prodLines = getProductionLines(sRecords, isMetric, durationDrillName);

          // calculate derived time fields
          setTimesBetween(prodLines);
          for (let j = 0; j < prodLines.length; j++) {
            let pl = prodLines[j];
            pl.installTime = roundToFixed(minutesBetween(pl.timeStart, pl.timeFinish), 2);
            let dtOnly = new Date(pl.timeStart + '');
            dtOnly.setHours(0, 0, 0);
            pl.dateOnly = dtOnly;
          }
        }
        else {
          // if there is bad time data, alert user
          alert('Omnibox source file has bad data in the \'timeBegin\' and/or \'timeEnd\' fields.\nOutput fields \'date\', \'timeStart\', \'installTime\', \'dateOnly\' and \'timeBetweenCmcs\' will be incorrect in the result.');

          // then generate partial production lines without time-related calcs
          prodLines = getPartialProductionLines(sRecords, isMetric, durationDrillName);
          // fill in today's date so that the results can still be exported
          let todayDt = newDate();
          for (const pl of prodLines) {
            pl.date = todayDt;
            pl.timeStart = todayDt;
            pl.timeFinish = todayDt;
          }
        }

        const delimString = generateProdLinesCsv(prodLines, '\t', true);

        // console.log(prodLines);
        // console.log(delimString);      

        resolve({
          prodLines,
          delimString
        });
      }
      reader.onerror = () => {
        reject(new Error('Failed to read file'));
      }
    }
  });
}